import { environment } from "../../../../Environments/environment";
import { GetAsyncHelper, PostAsyncHelper } from "../../../../redux/interfaces/types";

export const GetAiResponse = async(message)=>{
    let obj = {
        userContent:message??""
    }

    let api_url = `${environment.apiUrl}muv-ai/prompt`
    const response  =  await PostAsyncHelper(api_url, obj)
    const results = response?.data

    return results || null;
}

export const GetAIEstablishment = async(id)=>{

    let api_url = `${environment.apiUrl}/establishment/main/en/${id}`
    const response  =  await GetAsyncHelper(api_url)
    const results = response?.data

    return results || null;
}



export const GetAiSuggestions = async(data)=>{
    const message = data?.message;
    const member_id = data?.member_id;
    const muvgpt_session_id = data?.muvgpt_session_id

    let obj = {
        userContent:message??"",
        uuid: member_id,
        muvgpt_session_id,
        start_over: data?.start_over || null,
        muvSystemInfo:{
            entity:data?.entity || null,
            entity_id:data?.entity_id || null,
        }
    }

    let api_url = `${environment.apiUrl}muv-ai/homePagePromptUsingJson`

    
    // let api_url = `${environment.apiUrl}muv-ai/workWithPrompAndCoordinates`
    const response  =  await PostAsyncHelper(api_url, obj)
    const results = response?.data

    return results || null;
}

